import { render, staticRenderFns } from "./whitelabel-comission-report.vue?vue&type=template&id=f31c98e0&"
import script from "./whitelabel-comission-report.vue?vue&type=script&lang=js&"
export * from "./whitelabel-comission-report.vue?vue&type=script&lang=js&"
import style0 from "./whitelabel-comission-report.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports